import { addDays, startOfMonth, startOfWeek } from "date-fns";
import {
	DAY_GRID_WEEKS,
	DAYS_IN_WEEK,
	WEEK_STARTS_ON_MONDAY,
} from "web_myplann/Shared/Components/FlatRow/datePanelHelpers";

export const getDayGridDays = (month: Date): Date[] => {
	const firstDay = startOfWeek(startOfMonth(month), {
		weekStartsOn: WEEK_STARTS_ON_MONDAY,
	});

	return Array.from({ length: DAYS_IN_WEEK * DAY_GRID_WEEKS }, (_, index) =>
		addDays(firstDay, index),
	);
};
